import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, makeStyles, Typography } from "@material-ui/core";

import { ShowBars } from "./showBars";
import { getData, nFormatter } from "../../../../services";
import { CarouselContainer } from "./CarouselContainer";
import { ShaDowBox } from "../../../../components/boxes";
import { ActionButtonsGroup } from "../../../../components/buttonsGroup/ActionButtonsGroup";
import { CAROUSEL_TYPE, DEMO_CAROUSEL_TYPE } from "../../constants";
import { DEMO_ACCOUNT_EMAIL } from "../../../../redux/auth";

export const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: "bold",
    textAlign: "center",
    paddingBottom: theme.spacing(4),
  },
  actionButtonsGroup: {
    color: "green",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
}));

export const PortfolioOptimizationTab = () => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);
  const currencySymbol = user.currency.symbol;
  const [step, setStep] = useState(0);
  const [buildings, setBuildings] = useState([]);
  const [sortedBuildings, setSortedBuildings] = useState([]);
  const carouselType = (user.email !== DEMO_ACCOUNT_EMAIL ? DEMO_CAROUSEL_TYPE : CAROUSEL_TYPE)(
    user.unit_system,
    currencySymbol
  );
  const suffixes = carouselType.map((item) => item?.suffix);
  const { cluster, segments, selectedCountries } = useSelector((state) => state.selectCSC);

  useEffect(() => {
    getData("praas/v1/buildings/performing/", (results) => {
      setBuildings(results);
    });
  }, [cluster, segments, selectedCountries]);

  useEffect(() => {
    if (buildings.length) {
      sortBuildings(buildings, carouselType[step].key);
    }
  }, [step, buildings]);

  const sortBuildings = (buildings, key) => {
    const sorted = buildings.sort((a, b) => b[key] - a[key]);
    const firstBuilding = sorted[0];
    const maxValue = firstBuilding[key] > 0 ? firstBuilding[key] : 1;
    const displayedBuildings = sorted
      .map((building) => ({
        id: building.id,
        name: building.name,
        address: building.address,
        value: building[key],
        displayValue: nFormatter(building[key]),
        width: `${(building[key] / maxValue) * 100}%`,
      }))
      .filter((building) => building.value > 0)
      .slice(0, 15);
    setSortedBuildings(displayedBuildings);
  };

  const previousStep = () => {
    if (step === 0) return;
    setStep((prev) => prev - 1);
  };

  const nextStep = () => {
    if (step === carouselType.length - 1) return;
    setStep((prev) => prev + 1);
  };

  return (
    <Box>
      <Box className={classes.actionButtonsGroup}>
        <ActionButtonsGroup hideIntegrateBtn />
      </Box>
      <ShaDowBox style={{ padding: "32px 30px 40px" }}>
        <Typography className={classes.title}>TOP PERFORMING BUILDINGS</Typography>
        <CarouselContainer
          step={step}
          nextStep={nextStep}
          previousStep={previousStep}
          carouselType={carouselType}
        >
          <ShowBars buildings={sortedBuildings} suffix={suffixes[step]} />
        </CarouselContainer>
      </ShaDowBox>
    </Box>
  );
};
